var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ais-instant-search',{attrs:{"search-client":_vm.searchClient,"index-name":"pages","routing":_vm.routing}},[_c('AlgoliaSearchContainer',{attrs:{"image":_vm.image,"ratio":_vm.ratio}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }